import { render, staticRenderFns } from "./NavbarBeforeLogin-v2.vue?vue&type=template&id=50b7a5f8&lang=pug"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports